export default __webpack_public_path__ + "static/media/status_banner.76de9115.png";